import { render, staticRenderFns } from "./LifecycleHistory.vue?vue&type=template&id=b1a8e90c"
import script from "./LifecycleHistory.vue?vue&type=script&lang=js"
export * from "./LifecycleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports